import React, { useEffect, useState } from "react";
import Activity from "./List";

const ActivityProperties = ({ activity }) => {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <React.Fragment>
            {collapsed && <a href="#" onClick={() => setCollapsed(false)}>View properties</a>}
            {!collapsed && <a href="#" onClick={() => setCollapsed(true)}>Hide properties</a>}

            {!collapsed && (
                <code style={{display: 'block'}}>
                    <pre>
                        {JSON.stringify(activity?.properties, null, 2)}
                    </pre>
                </code>
            )}

        </React.Fragment>
    )
};

export default ActivityProperties;
